// extracted by mini-css-extract-plugin
export var divider = "_r5-0";
export var systemMessage = "_r5-1";